<div class="top-area">
  <div class="title-area">
    <h2>Painel de Controle de Distribuição de Leads</h2>
    <h3>Monitore o desempenho das filas de distribuição, gere relatórios e crie novas filas sempre que precisar.</h3>
  </div>
  <div class="actions-area">
    <button class="btn-red" routerLink="/fila-de-distribuicao/configurar" routerLinkActive="active">Criar Nova Fila</button>
    <button class="btn-white">Gerar Relatório</button>
    <router-outlet></router-outlet>
  </div>
</div>